import api                from '@/api'
import jsPDF              from 'jspdf';
import JSPM               from 'jsprintmanager'
import fmt                from '@/components/mixins/fmt.js'
JSPM.JSPrintManager.auto_reconnect = true;
JSPM.JSPrintManager.start();
export default {
  mixins:[fmt],
    methods: {
    async pdfCustomerReceipt(saleId)
    { 
      let _this = this
      const sp   = {'sp'             : 'spCustomerSaleReceipt'}
      const data = {'saleId'         : saleId,'companyId': this.company.Id}
      
      const json  = Object.assign(data, sp)
      console.log(data)
      let items = []
      let payments = []
      let logo = ''

      await api.post(json).then(res => {
        if(res.status == 200)
        {
          items = res.data.recordsets[0]
          payments = res.data.recordsets[1]
          if(res.data.recordsets[2].length > 0)
          {
            logo = res.data.recordsets[2][0].logo
            //this.imgData = logo
            
          }
          //console.log(items)
        }
      })
      
      if(items.length == 0)
      {
        console.log('NO DATA')
        return
      }
      
      JsBarcode("#barcode", 'S' + saleId, {format: "code39"});
      const img = document.querySelector('img#barcode');
      

      function headRows() {
        return [
          { 'id':'',  ean13: 'Codice', description: 'Descrizione', price: 'Importo', discount: 'Sconto',total : 'Totale' },
        ]
      }


      const bodyRows = (items) => {
        
        const rowCount = items.length || 25
        var body = []
        for (var j = 0; j <= rowCount-1; j++) {
          body.push({
            id           : j+1,
            ean13        : items[j]['barcode']  ,
            description  : items[j]['brand'] + ' ' +  items[j]['category'] + ' ' + items[j]['sku'] + ' ' + items[j].color + ' ' + items[j].size ,
            price        : this.fmt1(items[j]['price']) ,
            discount     : items[j]['discount'] + '%' ,
            total        : this.fmt1(items[j]['rowTotal'])
          })
        }
        return body
      }

    const doc = new jsPDF({orientation: 'portrait' ,unit:'mm',format : 'a4'})
      var totalPagesExp = '{total_pages_count_string}'
    
    const p   = 25
    let pages = parseInt(items.length / p) === items.length / p ?  items.length / p : parseInt(items.length / p)  + 1
    const mb  = 40
    //alert(pages)  

      doc.autoTable({
        theme        : 'grid',
        startY       : 60, 
        //tableWidth: 'wrap',  
        
        margin: { bottom: mb},
        
        head         : headRows(),
        body         : bodyRows(items),
        //rowPageBreak: 'avoid',
        //showHead     : 'firstPage',
        //pageBreak    : 'auto',
        
       //foot        : footRows(payments),
        headStyles   : {fillColor: "#0d47a1",}, 
        //startY       : doc.internal.getNumberOfPages() > 1 ? doc.autoTableEndPosY() + 20 : 200,
        columnStyles : {
                  3  : {halign: 'right'},
                  4  : {halign: 'right'},
                  5  : {halign: 'right'},
                       },
        bodyStyles   : {
                        fontSize   : 8  
                      },               
        didParseCell: data => {
          if (data.cell && data.cell.section === 'head') {
            switch (data.cell.raw) {
              case "Importo":
                data.cell.styles.halign  = 'right'
              case "Sconto":
                data.cell.styles.halign  = 'right'
              case "Totale":
                  data.cell.styles.halign = 'right'
                break;
              default:
                data.cell.styles.halign   = 'left'
                break;
            }
          }
        },
        didDrawPage: function (data) {
          // Header
          
         // console.log(data)
          data.settings.margin.top = 60
          data.settings.margin.bottom = mb

          if(logo)
          {
            doc.addImage(logo, 'JPEG', data.settings.margin.left , 5, 60,40)  
          }

          doc.setFontSize(12)
          //doc.text(items[0].tel ? items[0].tel : '', data.settings.margin.left + 10, 27)
          doc.setFontSize(10)
          doc.text('VENDITA DEL ' + items[0].create_at, data.settings.margin.left + 140, 35)

                   
          doc.setDrawColor(0,0,0)
          doc.setLineWidth(0)
          doc.roundedRect(10, 40, 190, 15,5,5);
          doc.setFontSize(15)
          doc.text(items[0].customer ? items[0].customer : 'CLIENTE RETAIL' , data.settings.margin.left + 10 , 50)
          
          if (img) 
          {
            doc.addImage(img.src, 'JPEG', data.settings.margin.left + 140, 5, 45, 25)
          }
            
          // Footer
          let str = 'Pag. ' + doc.internal.getNumberOfPages()
          
          // Total page number plugin only available in jspdf v1.0+
          if (typeof doc.putTotalPages === 'function') {
            str = str + ' di ' + totalPagesExp

          }
          
          
          
          if(doc.internal.getNumberOfPages() == pages)
          {  

            doc.autoTable({
            theme        : 'grid',  
            
            headStyles   : { fontSize: 8,fillColor:[0, 154, 46] },
            startY       : 260,  
            bodyStyles   : {
              fontSize   : 12  
            },
            columnStyles: {
                      0: {
                        fontStyle   : 'bold',
                        halign      : "right"
                      }, 
  
                      1: {
                          
                          fontStyle : 'bold',
                          halign    : 'right', 
                      },
                      2: {
                          
                          fontStyle : 'bold',    
                          halign    : 'right', 
                      },
                      3: {
                          
                          fontSize   : 18,
                          fontStyle  : 'bold',
                          halign     : 'right', 
  
                      },
                  },
            
            head:  [['TOTALE VENDITA','ABBUONO', 'PAGATO', 'A SALDO €']],
            body: [
              [ _this.fmt1(items[0].total),
                _this.fmt1(items[0].totalDiscount),
                _this.fmt1(payments[0].total_paid)
              , _this.fmt1(Number(items[0].total) - Number(items[0].totalDiscount)-Number(payments[0].total_paid))]],          
  
          });


          
        }
        else
        {
            doc.text('SEGUE ' , data.settings.margin.left + 160 , 270)
        }
          
  
  


          doc.setFontSize(10)

          // jsPDF 1.4+ uses getWidth, <1.4 uses .width
          const pageSize = doc.internal.pageSize
          const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
          doc.text(str, data.settings.margin.left, pageHeight - 5)


        },
        //margin: { top: 30 },
      })

      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === 'function') 
      {
        doc.putTotalPages(totalPagesExp)
      }




          let fileName1 = 'Report_' + Date.now().toString()
          window.open(doc.output('bloburl', { filename: fileName1 }), '_blank');
          return

          
    }

    },
    printTicketCortesia(receiptText,sale)
    {
    

   
    function jspmWSStatus() {
        if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open)
            return true;
        else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Closed) {
            alert('JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm');
            return false;
        }
        else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Blocked) {
            alert('JSPM has blocked this website!');
            return false;
        }
    }

 

   
    const GS = '\x1d'  
    const esc = '\x1B'; //ESC byte in hex notation
    const newLine = '\x0A'; //LF byte in hex notation

    var cmds = esc + "@"; //Initializes the printer (ESC @)
   
    cmds += newLine + newLine + newLine  

     

    // HEADER 
    receiptText.forEach(row =>{
      if(row.type == 'H')
      {
        if(row.order_by == 1)
        {   
               
            cmds += esc + 'a' + '\x01'
            cmds += esc + '!' + '\x38'; //Emphasized + Double-height + Double-width mode selected (ESC ! (8 + 16 + 32)) 56 dec => 38 hex
            cmds += row.text  //text to print
            cmds += newLine;
            
        }
        else
        {
            cmds += esc + '!' + '\x00'; //Character font A selected (ESC ! 0)
            cmds += row.text  //text to print
            cmds += newLine;
        }
        
      }

    })
    
    
    cmds += newLine;

    cmds += esc + 'a' + '\x01'
    cmds += GS + '!' +  '\x01'
    cmds += 'SCONTRINO DI CORTESIA'    //text to print

  
    
    const data = sale.create_at + ' ' + sale.hour_at
    
    cmds += esc + '!' + '\x00'; //Character font A selected (ESC ! 0)
    
    cmds += newLine
    cmds += newLine
    cmds += newLine
    cmds += data    //text to print
    cmds += newLine

    cmds += newLine


    // BARCODE  
    cmds += esc + 'a' + '\x01'
    cmds += GS  + 'h' + '\x50'
    cmds += GS  + 'H' + '\x02'
    cmds += GS  + 'f' + '\x01'
    cmds += GS  + 'k' + '\x04' + 'S' +  sale.saleId + '\x00'
    
    cmds += newLine
    cmds += newLine
    cmds += newLine


    // FOOTER
    receiptText.forEach(row=>{

      if(row.type=='F')
      {

        if(row.order_by > 0)
        {
          cmds += row.text   //text to print
          cmds += newLine
        }

      }
    })

    cmds += newLine
    cmds += newLine
    cmds += newLine
    cmds += newLine
    cmds += newLine

    cmds += GS + 'V' + '\x01'   
    cmds += newLine
     
    
     if (jspmWSStatus()) {
            //Create a ClientPrintJob
            var cpj = new JSPM.ClientPrintJob();
            cpj.clientPrinter = new JSPM.DefaultPrinter();
            
            /*
            //Set Printer type (Refer to the help, there many of them!)
            if ($('#useDefaultPrinter').prop('checked')) {
                cpj.clientPrinter = new JSPM.DefaultPrinter();
            } else {
                cpj.clientPrinter = new JSPM.InstalledPrinter($('#installedPrinterName').val());
            }
            */

            cpj.printerCommands = cmds;
            //Send print job to printer!
            cpj.sendToClient();
            

     }


  },

  }